import React, { useState, useEffect } from 'react'
import {
    Button,
    ButtonContainer,
    Container,
    ErrorMessage,
    FFile,
    FInput,
    FInputArea,
    FInputWrapper,
    Header,
    Icon,
    ModalContainer,
    ModalContent,
    OverlayLoading,
    Title
} from '../components/tambahTugas'
import { iconClose } from '../../../../assets'
import API from '../../../../config/api';
import swal from 'sweetalert';
import { Loading } from '../../../../components/atoms';

const AddBank = (props) => {
    const { handleSubmitBank } = props
    const token = localStorage.getItem('token')
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [type, setType] = useState();
    const [formData, setFormData] = useState({
        bank_name: "",
        name: "",
        bank_branch: "",
        number: ""
    })

    const [errors, setErrors] = useState({})
    const validate = () => {
        const newErrors = {}
        if (!formData.bank_name) newErrors.bank_name = "Nama Bank Wajib dipilih"
        if (!formData.name) newErrors.name = "name wajib diisi"
        if (!formData.bank_branch) newErrors.bank_branch = "Bank branch wajib dipilih"
        if (!formData.number) newErrors.number = "Nomor rekening wajib diisi"
        return newErrors
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);
        console.log(formData)
        if (Object.keys(newErrors).length === 0) {
            handleSubmitBank(formData)
        }
    };




    return (
        <form onSubmit={handleSubmit}>
            <FInputWrapper>
                <label htmlFor="bank_name">Bank</label>
                <select
                    id="bank_name"
                    name="bank_name"
                    value={formData.bank_name}
                    onChange={handleChange}
                    style={{ width: "109%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                >
                    <option value="">--Pilih</option>
                    <option value="BNI">BNI</option>
                    <option value="MANDIRI">MANDIRI</option>
                </select>
                {errors.bank_name && <ErrorMessage>{errors.bank_name}</ErrorMessage>}
            </FInputWrapper>
            <FInputWrapper>
                <label htmlFor="bank_branch">Cabang Bank</label>
                <select
                    id="bank_branch"
                    name="bank_branch"
                    value={formData.bank_branch}
                    onChange={handleChange}
                    style={{ width: "109%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                >
                    <option value="">--Pilih</option>
                    <option value="Banjarmasin">Banjarmasin</option>
                    <option value="Marabahan">Marabahan</option>
                </select>
                {errors.bank_branch && <ErrorMessage>{errors.bank_branch}</ErrorMessage>}
            </FInputWrapper>
            <FInputWrapper>
                <FInput
                    name="name"
                    placeholder="Nama rekening"
                    value={formData.name}
                    onChange={handleChange}
                />
                {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
            </FInputWrapper>
            <FInputWrapper>
                <FInput
                    name="number"
                    placeholder="Nomor rekening"
                    value={formData.number}
                    onChange={handleChange}
                />
                {errors.number && <ErrorMessage>{errors.number}</ErrorMessage>}
            </FInputWrapper>

            <ButtonContainer>
                <Button type="submit">Simpan</Button>
            </ButtonContainer>
        </form>
    )
}

export default AddBank
